<template>
  <Page
    :loading="isLoadingPage"
    :spinning="isSpinning"
    class="base-table"
  >
    <PageTitle>Indholdsstoffer ({{ getAllSubstances.length }})</PageTitle>
    <p v-if="getAllSubstances.length === 0">
      Der er ingen indholdsstoffer oprettet.
    </p>

    <section>
      <TableTopFilterAndSearch
        button-label="Opret indholdsstof"
        :search-term="searchTerm"
        @input-search="searchTerm = $event"
        :filter-by="filterBy"
        button-link="substances.create"
        @input-filter="filterBy = $event"
      />

      <TableRowHeader :sort="sort" />

      <section v-if="getAllSubstances.length">
        <VueAutoVirtualScrollList
          class="scrollbar"
          :total-height="550"
          :default-height="45"
          style="width: 100%;"
        >
          <router-link
            v-for="(item, itemIndex) in getFilteredGlobalNotes"
            :key="itemIndex"
            :to="onRowItemClick(item)"
          >
            <Box>
              <div class="row">
                <div class="col-xs-3">
                  {{ item.name }}
                </div>
                <div class="col-xs-3">
                  <p>{{ item.publishedDate | HumanDate | IsPublished }}</p>
                </div>
                <div class="col-xs-3">
                  <p>{{ item.nextPublishedDate | HumanDate }}</p>
                </div>
                <div class="col-xs-3">
                  <p>{{ item.deleted | IsDeleted }}</p>
                </div>
              </div>
            </Box>
          </router-link>
        </VueAutoVirtualScrollList>
      </section>
    </section>
  </Page>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import VueAutoVirtualScrollList from 'vue-auto-virtual-scroll-list';
import Box from '../../components/Box.vue';
import Page from '../Page.vue';
import TableRowHeader from '../../components/TableRowHeader.vue';
import TableTopFilterAndSearch from '../../components/TableTopFilterAndSearch.vue';
import Pageload from '../../mixins/Pageload';
import IsPublished from '../../filters/IsPublished';
import IsDeleted from '../../filters/IsDeleted';
import HumanDate from '../../filters/HumanDate';
import sortByKeyAndDirection from '../../mixins/sortByKeyAndDirection';

export default {
    name: 'GlobalNotes',
    mixins: [Pageload, sortByKeyAndDirection],
    components: {
        TableTopFilterAndSearch, TableRowHeader, Page, VueAutoVirtualScrollList, Box,
    },
    filters: {
        IsPublished,
        HumanDate,
        IsDeleted,
    },
    data() {
        return {
            searchTerm: '',
            filterBy: 'all',
        };
    },
    computed: {
        ...mapGetters('substances', [
            'getAllSubstances',
        ]),
        getFilteredGlobalNotes() {
            return this.getAllSubstances
                .filter(note => note.name.toLowerCase().indexOf(this.searchTerm.toLowerCase()) > -1)
                .filter((note) => {
                    switch (this.filterBy) {
                    case 'active':
                        return !note.deleted;
                    case 'deleted':
                        return note.deleted;
                    default:
                        return true;
                    }
                })
                .sort(this.sortByKeyAndDirection);
        },
    },
    methods: {
        ...mapActions('substances', [
            'loadSubstances',
        ]),
        onRowItemClick(item) {
            return { name: 'substances.single', params: { id: item.id }, query: { date: window.moment().format('YYYY-MM-DD HH:mm') } };
        },
    },
    async created() {
        try {
            await this.loadSubstances();
            this.pageloaded();
        } catch (error) {
            //
        }
    },
};
</script>

<style lang="scss" scoped>
.scrollbar {
}
</style>
